import axios from "axios";
import { getUserName } from "../../utils/localStoarege";
import { enquiriesCRUDApi, localToken } from "../../constants/apis/new_hud_apis";

export const getEnquiries = async ({ isDoctor }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${localToken}`,
        },
    };
    const response = await axios.get(`${isDoctor ? enquiriesCRUDApi : `${enquiriesCRUDApi + "?center=" + getUserName()}`}`, config);
    return response;
};

export const addNewEnquiry = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${localToken}`,
        },
    };
    const response = await axios.post(enquiriesCRUDApi, data, config);
    return response;
};
